import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Projects from "./pages/Projects";
import Modules from "./pages/Modules";
import PaintMeasure from "./pages/PaintMeasure";
import PriceCodes from "./pages/PriceCodes";
import CompanySettings from "./pages/CompanySettings";
import Templates from "./pages/Templates";
import Quotes from "./pages/Quotes";
import Facturen from "./pages/Facturen";
import FactuurDetail from "./pages/FactuurDetail";
import Help from "./pages/Help";
import LoginScreen from "./pages/LoginScreen";
import AuthCallback from "./pages/AuthCallback";
import BetaSignup from "./pages/BetaSignup";
// v6 F42 — BetaWaitlistAdmin import verwijderd uit EmmaMeasure™.
// Wachtlijst-/tester-administratie draait voortaan via EmmaForge™ Founder
// Dashboard. Component-bestand blijft bestaan zodat oude waitlist-data
// gecontroleerd kan worden gemigreerd naar EmmaForge™.
import { AuthProvider } from "./lib/auth";
import { MeasurementJobsProvider } from "./state/measurementJobsStore";
import { NotificationCenter } from "./components/measurement-jobs/NotificationCenter";

// v6 F9.8 — Emergent Google OAuth gate.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

// Wrap protected pages with <ProtectedRoute><Layout>...</Layout></ProtectedRoute>
const Protected = ({ children }) => (
  <ProtectedRoute>
    <Layout
      topBarExtras={<NotificationCenter />}
    >{children}</Layout>
  </ProtectedRoute>
);
// v6 F42 — <AdminOnly> route-wrapper verwijderd (was enkel in gebruik voor
// /admin/beta-aanmeldingen). Kan terugkeren als er in de toekomst opnieuw
// admin-only routes in EmmaMeasure™ nodig zijn.

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MeasurementJobsProvider>
            <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/beta-aanmelden" element={<BetaSignup />} />

            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/klanten" element={<Protected><Clients /></Protected>} />
            <Route path="/projecten" element={<Protected><Projects /></Protected>} />
            <Route path="/projecten/:projectId" element={<Protected><PaintMeasure /></Protected>} />
            <Route path="/offertes" element={<Protected><Quotes /></Protected>} />
            <Route path="/facturen" element={<Protected><Facturen /></Protected>} />
            <Route path="/facturen/:id" element={<Protected><FactuurDetail /></Protected>} />
            <Route path="/prijslijst" element={<Protected><PriceCodes /></Protected>} />
            <Route path="/sjablonen" element={<Protected><Templates /></Protected>} />
            <Route path="/modules" element={<Protected><Modules /></Protected>} />
            <Route path="/instellingen" element={<Protected><CompanySettings /></Protected>} />
            {/* v6 F42 — Route /admin/beta-aanmeldingen verwijderd uit EmmaMeasure™.
                Zie EmmaForge™ Founder Dashboard voor testerbeheer / trial / pro. */}
            <Route path="/help" element={<Protected><Help /></Protected>} />
          </Routes>
          </MeasurementJobsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
